import * as Yup from 'yup';
import { getTemplateFormGridColumnSpan } from '../../../utils/templateFormGridUtil';
import { TemplateFormHelperText } from '../../TemplateFormHelperText';
import { TemplateFormComponentMeta } from '../../../interfaces/template-form-component-meta';
import { TemplateFormFieldValidationsFactory } from '../../../factories/templateFormFieldValidationFactory';
import { TemplateLiteralValueField } from '../TemplateLiteralValueField';
import { TemplateLiteralValueFieldMetaProps } from '../interfaces/template-form-literal-value-field-meta';

export const TemplateLiteralValueFieldMeta: TemplateFormComponentMeta<
  TemplateLiteralValueFieldMetaProps,
  {
    metadata_configuration?: {
      [key: string]: string;
    };
    generated_value?: string;
  }
> = {
  component: TemplateLiteralValueField,
  MetadataFactory: field => ({
    dataId: `template-form-${field.name}`,
    displayName: field.display_name ?? '',
    value: field.component?.generated_value as string,
    className: getTemplateFormGridColumnSpan(field.size),
    helperText: TemplateFormHelperText({ helperText: field.helper_text, fieldName: field.name })
  }),
  ValidationSchemaFactory: field => TemplateFormFieldValidationsFactory(field, Yup.string())
};
